import React from 'react';
import { motion } from 'framer-motion';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/fTLQ1o1CRb8Qw17dScZP8o/1.jpg', 'https://cdn.magicpatterns.com/uploads/cnMZmjQ3rdzV7nEGSw6ZVX/2.jpg', 'https://cdn.magicpatterns.com/uploads/8sQE9vo12sarqKwSNkDffM/3.jpg', 'https://cdn.magicpatterns.com/uploads/7d2GDsM7QFfr5kDy3Y5w5u/4.jpg', 'https://cdn.magicpatterns.com/uploads/jh3qF1Ke6THLfWpqcFUffF/5.jpg', 'https://cdn.magicpatterns.com/uploads/rNjeLKWzHJxK3GeAV5NEkc/6.jpg'];
export function ScrollingBanner() {
  return <div className="w-full bg-black py-6 overflow-hidden border-y border-gray-800" data-id="element-46">
      <div className="flex relative" data-id="element-47">
        <motion.div className="flex gap-6 px-4" animate={{
        x: ['0%', '-50%']
      }} transition={{
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 30,
          ease: 'linear'
        }
      }} style={{
        width: '200%'
      }} data-id="element-48">
          {[...IMAGES, ...IMAGES].map((src, index) => <div key={index} className="flex-shrink-0 h-32 md:h-40 rounded-lg overflow-hidden border border-gray-800 relative" style={{
          aspectRatio: 'auto'
        }} data-id="element-49">
              <img src={src} alt={`Categoría ${index % IMAGES.length + 1}`} className="h-full w-auto object-contain" data-id="element-50" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" data-id="element-51" />
            </div>)}
        </motion.div>
      </div>
    </div>;
}